import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiLock, FiPlay, FiCircle } = FiIcons;

export const lessonStatusMeta = {
  completed: { icon: FiCheck, label: 'Completed', className: 'completed' },
  'in-progress': { icon: FiPlay, label: 'In progress', className: 'in-progress' },
  available: { icon: FiCircle, label: 'Available', className: 'available' },
  locked: { icon: FiLock, label: 'Locked', className: 'locked' }
};